class LpOtwParentReviews extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-reviews-track]');
    this.nav = this.querySelector('[data-reviews-nav]');
    this.prevButton = this.querySelector('[data-reviews-prev]');
    this.nextButton = this.querySelector('[data-reviews-next]');
    this.toggles = [...this.querySelectorAll('[data-reviews-toggle]')];
    if (!this.track) return;

    this.prevButton?.addEventListener('click', this.handlePrev);
    this.nextButton?.addEventListener('click', this.handleNext);
    this.track.addEventListener('scroll', this.handleScroll, { passive: true });
    this.toggles.forEach((toggle) => toggle.addEventListener('click', this.handleToggle));
    window.addEventListener('resize', this.handleResize);

    this.setupClamps();
    this.updateNav();
  }

  disconnectedCallback() {
    this.prevButton?.removeEventListener('click', this.handlePrev);
    this.nextButton?.removeEventListener('click', this.handleNext);
    this.track?.removeEventListener('scroll', this.handleScroll);
    this.toggles.forEach((toggle) => toggle.removeEventListener('click', this.handleToggle));
    window.removeEventListener('resize', this.handleResize);
  }

  get step() {
    const card = this.track.querySelector('[data-reviews-card]');
    if (!card) return this.track.clientWidth;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  get reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  scrollByStep(direction) {
    this.track.scrollBy({ left: direction * this.step, behavior: this.reduceMotion ? 'auto' : 'smooth' });
  }

  handlePrev = () => this.scrollByStep(-1);

  handleNext = () => this.scrollByStep(1);

  handleScroll = () => {
    if (this.rafId) return;
    this.rafId = requestAnimationFrame(() => {
      this.rafId = null;
      this.updateNav();
    });
  };

  handleResize = () => {
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.setupClamps();
      this.updateNav();
    }, 150);
  };

  handleToggle = (event) => {
    const toggle = event.currentTarget;
    const quote = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!quote) return;
    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    quote.classList.toggle('is-clamped', expanded);
    toggle.setAttribute('aria-expanded', String(!expanded));
    toggle.textContent = expanded ? toggle.dataset.labelMore : toggle.dataset.labelLess;
  };

  // Clamp only the quotes that overflow; the toggle stays hidden on the rest.
  setupClamps() {
    this.toggles.forEach((toggle) => {
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      const quote = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!quote) return;
      quote.classList.add('is-clamped');
      const overflows = quote.scrollHeight > quote.clientHeight + 1;
      quote.classList.toggle('is-clamped', overflows);
      toggle.hidden = !overflows;
    });
  }

  updateNav() {
    if (!this.nav || !this.prevButton || !this.nextButton) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
    const scrollable = maxScroll > 0;
    this.nav.hidden = !scrollable;
    this.prevButton.disabled = this.track.scrollLeft <= 0;
    this.nextButton.disabled = this.track.scrollLeft >= maxScroll;
  }
}

if (!customElements.get('lp-otw-parent-reviews')) {
  customElements.define('lp-otw-parent-reviews', LpOtwParentReviews);
}
